import React from "react";
import { useCart } from "../context/CartContext";
import { Link } from "react-router-dom";

const Header = () => {
    const { cartItems } = useCart();
    const itemCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);

    return (
        <div className="flex items-center justify-between px-8 py-4 bg-gray-100">
            {/* Logo - already links to homepage */}
            <Link to="/" className="flex items-center gap-2">
                <img src="/images/logo.png" alt="Sasta Bazaar Logo" className="h-10 w-10 object-contain" />
                <span className="text-2xl font-bold text-gray-800">Sasta Bazaar</span>
            </Link>
            {/* Action buttons: Add Product (Admin) + Cart */}
            <div className="flex gap-4 items-center">
                {/* Add Product link */}
                <Link
                    to="/admin/add-product"
                    className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition-all"
                >
                    + Add Product
                </Link>

                {/* Cart link */}
                <Link
                    to="/cart"
                    className="bg-orange-400 text-white px-5 py-2 rounded hover:bg-orange-500 transition-all"
                >
                    Cart ({itemCount})
                </Link>
            </div>
        </div>
    );
};

export default Header;
